export type SignupDiscount = {
  amount: number
  recurrence: number
}

export type BoxDiscounts = {
  [boxType: string]: SignupDiscount[]
}

// Recurrence is the number of orders that the discount applies to.
// Needs to add up to the total number of orders, which is calculated as
// ORDER_FREQUENCY multiplied by PROMOTION_DURATION.
export const CONTROL_DISCOUNT_STAGES: SignupDiscount[] = [
  { amount: 50, recurrence: 1 },
  { amount: 40, recurrence: 1 },
  { amount: 20, recurrence: 6 },
]

export const TAPERED_DISCOUNT_STAGES: SignupDiscount[] = [
  { amount: 50, recurrence: 1 },
  { amount: 40, recurrence: 1 },
  { amount: 20, recurrence: 2 },
  { amount: 10, recurrence: 4 },
]

export const PROMOTION_DURATION = 2 // months
export const ORDER_FREQUENCY = 4 // orders per month

export const boxDiscounts: BoxDiscounts = {
  '2x1': CONTROL_DISCOUNT_STAGES,
  '3x1': CONTROL_DISCOUNT_STAGES,
  '4x1': CONTROL_DISCOUNT_STAGES,
  '5x1': CONTROL_DISCOUNT_STAGES,
  '2x2': CONTROL_DISCOUNT_STAGES,
  '3x2': CONTROL_DISCOUNT_STAGES,
  '4x2': CONTROL_DISCOUNT_STAGES,
  '5x2': CONTROL_DISCOUNT_STAGES,
  '2x3': CONTROL_DISCOUNT_STAGES,
  '3x3': CONTROL_DISCOUNT_STAGES,
  '4x3': CONTROL_DISCOUNT_STAGES,
  '5x3': CONTROL_DISCOUNT_STAGES,
  '2x4': CONTROL_DISCOUNT_STAGES,
  '3x4': CONTROL_DISCOUNT_STAGES,
  '4x4': CONTROL_DISCOUNT_STAGES,
  '5x4': CONTROL_DISCOUNT_STAGES,
  '2x5': CONTROL_DISCOUNT_STAGES,
  '3x5': CONTROL_DISCOUNT_STAGES,
}
